// extracted by mini-css-extract-plugin
module.exports = {"overlay":"dnd_overlay__3zkDu","fadeIn":"dnd_fadeIn__3hCVr","spinner":"dnd_spinner__3bTyM","spin":"dnd_spin__3DOKP","label":"dnd_label__3Zqvy","pulse":"dnd_pulse__1zy1f"};